import { ColorPicker, IColor, IColorPickerStyles, Label, Stack } from '@fluentui/react';

const width = 240;
const colorPickerStyles: Partial<IColorPickerStyles> = {    
    root: {
        maxWidth: width,
        minWidth: width,
    },
    panel: {
        padding: 0,
    },
    colorRectangle: { height: 130 },
};

const MiniColorPicker: React.FunctionComponent<{label: string, value: string | IColor, onChange: (color: string) => void}> = ({label, value, onChange}) => {

    return <Stack>
        <Label>{label}</Label>
        <ColorPicker        
        color={value}
        onChange={(ev, color: IColor) => {
            onChange(color.str)
        }}
        alphaSliderHidden={false}
        showPreview={true}
        styles={colorPickerStyles}
        strings={{
            alphaAriaLabel: 'Alpha Slider: Use left and right arrow keys to change value, hold shift for a larger jump',
            hueAriaLabel: 'Hue Slider: Use left and right arrow keys to change value, hold shift for a larger jump',
        }}
    /></Stack>
}

export default MiniColorPicker;